export default "__VITE_ASSET__BiOGb5Xl__"